"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var styled_components_1 = (0, tslib_1.__importStar)(require("styled-components"));
function PieChart(_a) {
    var percentage = _a.percentage, _b = _a.size, size = _b === void 0 ? 32 : _b, _c = _a.color, color = _c === void 0 ? '#FF7A7A' : _c;
    return (React.createElement(StyledPie, { width: size, height: size, viewBox: "0 0 48 48", color: color },
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip-pie-from-border" },
                React.createElement("circle", { r: "16", cx: "24", cy: "24", width: "100", height: "100" }))),
        React.createElement("circle", { className: "circular-border", r: "21", cx: "24", cy: "24", fill: "none", style: {
                strokeWidth: '4',
                stroke: "".concat(color),
            } }),
        React.createElement("circle", { className: "pie", clipPath: "url(#clip-pie-from-border)", r: "16", cx: "24", cy: "24", fill: "none", style: {
                strokeWidth: '32',
                stroke: "".concat(color),
                strokeDasharray: "".concat(percentage, ", 100"),
            } })));
}
exports.PieChart = PieChart;
var fillup = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  from { stroke-dasharray: 0 100; }\n"], ["\n  from { stroke-dasharray: 0 100; }\n"])));
var StyledPie = styled_components_1.default.svg(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  background: transparent;\n  transform: rotate(-90deg);\n\n  .pie {\n    animation: ", " 1s ease-out forwards;\n  }\n"], ["\n  background: transparent;\n  transform: rotate(-90deg);\n\n  .pie {\n    animation: ", " 1s ease-out forwards;\n  }\n"])), fillup);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map